var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { hideApplicationLoader, showApplicationLoader, } from 'common/ApplicationLoader';
import { getFormData } from 'globals/global.functions';
import { postSignedUrlService, postUploadFileService, } from 'services/fileUploadService/fileUpload.service';
import { showError } from 'store/commonReducer/common.action';
export var UPLOAD_FILES = 'UPLOAD_FILES';
export var UPLOAD_FILES_STATUS_UPDATE = 'UPLOAD_FILES_STATUS_UPDATE';
export var UPLOAD_FILES_RESET = 'UPLOAD_FILES_RESET';
export var uploadFiles = function (params) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var fileNames, signedUrls, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(showApplicationLoader());
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                dispatch({
                    type: UPLOAD_FILES,
                    payload: {
                        filesUploadCount: params.files.length,
                    },
                });
                fileNames = params.files.map(function (file) { return file.resourceId; });
                return [4 /*yield*/, postSignedUrlService({
                        data: {
                            senior_id: params.senior_id,
                            files: fileNames,
                            version: params.version,
                        },
                    })];
            case 2:
                signedUrls = _a.sent();
                return [4 /*yield*/, dispatch(uploadFilesToAWS(signedUrls, params.files))];
            case 3:
                _a.sent();
                dispatch({
                    type: UPLOAD_FILES_RESET,
                });
                dispatch(hideApplicationLoader());
                return [2 /*return*/, true];
            case 4:
                error_1 = _a.sent();
                dispatch({
                    type: UPLOAD_FILES_RESET,
                });
                dispatch(hideApplicationLoader());
                dispatch(showError(error_1));
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
export var uploadFilesToAWS = function (signedUrls, files) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var filesToUpload, i, fileToUpload, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                filesToUpload = files.map(function (file) {
                    var signedUrl = signedUrls.filter(function (signedUrl) {
                        return signedUrl.resourceId === file.resourceId;
                    })[0];
                    var url = signedUrl.url, fields = signedUrl.fields;
                    var uploadApiData = getFormData(__assign(__assign({}, fields), { file: file.file }));
                    return {
                        url: url,
                        uploadApiData: uploadApiData,
                    };
                });
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < filesToUpload.length)) return [3 /*break*/, 6];
                fileToUpload = filesToUpload[i];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, postUploadFileService(fileToUpload)];
            case 3:
                _a.sent();
                // and update the count state one by one.
                dispatch({
                    type: UPLOAD_FILES_STATUS_UPDATE,
                    payload: {
                        uploadedFilesCount: i + 1,
                    },
                });
                return [3 /*break*/, 5];
            case 4:
                error_2 = _a.sent();
                console.log(error_2);
                throw error_2;
            case 5:
                i++;
                return [3 /*break*/, 1];
            case 6: return [2 /*return*/];
        }
    });
}); }; };
